import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getWorkRequestsPriorityAndStatusChart = (query: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `order-request/graph?where=` + query
  );
};
export const updateOrderRequest = (obj: any) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `order-request/update`,
    obj
  );
};
